<template>
    <app-table-simple table-layout="auto" column-width-auto no-overflow>
        <template #body>
            <tr v-for="rowNumber in rows" :key="`skeleton-${rowNumber}`">
                <td v-for="colNumber in cols" :key="`skeleton-${colNumber}`">
                    <v-skeleton-loader
                        max-width="100%"
                        :width="getRandomWidth()"
                        height="14"
                        type="image"
                        class="my-2"
                    />
                </td>
            </tr>
        </template>
    </app-table-simple>
</template>

<script>
export default {
    name: 'SkeletonTableSimple',
    components: {
        AppTableSimple: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/table/AppTableSimple'
            )
    },
    props: {
        rows: {
            type: Number,
            default: 5
        },
        cols: {
            type: Number,
            default: 3
        }
    },
    methods: {
        getRandomWidth(min = 20, max = 200) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }
    }
};
</script>
